import styled from "@emotion/styled";
import { Outlet } from "@tanstack/react-router";
import { Layout } from "antd5";

import { DialogManagerProvider } from "lib/providers/DialogManager";
import { PaywallProvider } from "lib/providers/Paywall";
import SettingsNav from "../../components/app_layout/vertical_nav/SettingsNav";

import css from "./AccountManagementPage.module.scss";

export const DEFAULT_ROUTE = "/account-management/subscription";

export enum Routes {
  FEED_SETTINGS = "/account-management/feed-settings",
  ACCOUNT = "/account-management/account",
  SUBSCRIPTION = "/account-management/subscription",
  NOTIFICATIONS = "/account-management/notifications",
  MY_TEAM = "/account-management/my-team",
  USAGE = "/account-management/usage",
  INTEGRATIONS_SETUP = "/account-management/integrations/setup",
  INTEGRATIONS = "/account-management/integrations",
  BID_SELF_SERVE = "/account-management/bid-self-serve",
  LEAD_STAGES = "/account-management/lead-stages",
  BID_STAGES = "/account-management/bid-stages",
  TONE_OF_VOICE = "/account-management/tone-of-voice",
  QUALIFICATION_REPORT = "/account-management/qualification-report",
  COGNISM_TOKEN = "/account-management/cognism-token",
  CONTACTS = "/account-management/contacts",
}

const PageLayout = styled(Layout)({
  height: "100vh",
});

export function AccountManagementLayout() {
  return (
    <PaywallProvider>
      <PageLayout>
        <SettingsNav />
        <div className={css.pageBackground}>
          <DialogManagerProvider>
            <Outlet />
          </DialogManagerProvider>
        </div>
      </PageLayout>
    </PaywallProvider>
  );
}
